import { HttpErrorCode } from 'widget/Errors/types/HttpErrorCode';
import { IGetTranslateFunctionResponse } from 'redux-i18n';
import { ReactNode } from 'react';

type ErrorMessage = {
  heading: string;
  link: {
    children: ReactNode;
    href: string;
    target?: string;
  };
  text: string;
};

export default function getErrorMsg(
  httpErrorCode: HttpErrorCode | number,
  translate: IGetTranslateFunctionResponse,
): ErrorMessage {
  const viewIheartCTA = translate('View iHeart.com');
  const errorDescription = translate("Oops, that wasn't supposed to happen.");

  switch (httpErrorCode) {
    case 400: // Bad Request
      return {
        heading: '400',
        link: {
          children: viewIheartCTA,
          href: 'https://www.iheart.com',
          target: '_blank',
        },
        text: errorDescription,
      };
    case 404: // Not Found
      return {
        heading: '404',
        link: {
          children: viewIheartCTA,
          href: 'https://www.iheart.com',
          target: '_blank',
        },
        text: errorDescription,
      };
    case 501: // Not Implemented
      return {
        heading: '501',
        link: {
          children: viewIheartCTA,
          href: 'https://www.iheart.com',
          target: '_blank',
        },
        text: translate("Oops, this feature isn't supported yet."),
      };
    default:
      // Internal Server Error
      return {
        heading: '500',
        link: {
          children: viewIheartCTA,
          href: 'https://www.iheart.com',
          target: '_blank',
        },
        text: errorDescription,
      };
  }
}
